import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { z } from 'zod'
import { isEmpty } from 'lodash'

const metricsSchema = z.object({
  date: z.string(),
  impressions: z.number(),
  clicks: z.number(),
  ctr: z.number(),
})
const dayOfWeekData = z.object({
  day_of_week: z.string(),
  impressions: z.number(),
  clicks: z.number(),
})
const conversionSchema = z.object({
  tag_name: z.string(),
  id: z.number(),
  tag_code: z.string(),
  conversions: z.number(),
})
const siteVisitorSchema = z.object({
  campaign: z.string(),
  first_campaign_uniques: z.number(),
  last_campaign_uniques: z.number(),
})

const summaryReportSchema = z.object({
  metrics: z.array(metricsSchema),
  dayOfWeekData: z.array(dayOfWeekData),
  conversions: z.array(conversionSchema),
  timeToConversion: z.string(),
  uniqueSiteVisitors: z.array(siteVisitorSchema),
})

type CampaignsSummaryReport = z.infer<typeof summaryReportSchema>

export const useGetCampaignsSummaryReport = ({
  filters,
}: {
  filters?: Record<string, unknown>
}): UseQueryResult<CampaignsSummaryReport, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<CampaignsSummaryReport, Error>(
    ['campaigns', 'summary', 'report', { queryParams }],
    ({ signal }) =>
      request<CampaignsSummaryReport>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/summary`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }),
    {
      keepPreviousData: true,
    },
  )
}
